import { render, staticRenderFns } from "./dataMark.vue?vue&type=template&id=730ea106&scoped=true&"
import script from "./dataMark.vue?vue&type=script&lang=js&"
export * from "./dataMark.vue?vue&type=script&lang=js&"
import style0 from "./dataMark.vue?vue&type=style&index=0&id=730ea106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730ea106",
  null
  
)

export default component.exports